<template>
  <div class="rounded p-5 text-center flex-grow-1">
    <router-link :to="route">
      <img
        :src="image"
        alt="menu1"
      >
      <div class="mt-4 text-holcim-dark-blue font-weight-bold font-size-20">
        {{ name }}
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'VbList21',
  props: {
    route: {
      type: String,
      require: true,
      defaultValue: '',
    },
    name: {
      type: String,
      require: true,
      defaultValue: '',
    },
    image: {
      type: String,
      require: true,
      defaultValue: '',
    },
  },
}
</script>
